import React, { useEffect, useRef, useState } from "react";
// ------------------ COMPONENTES DE PRIMEREACT------------------------------------------------
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";

// ------------------- COMPONENTES DE BASE------------------------------------------------------
import { toastShow } from "../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API-------------------------------------------------------
import {
  getEstadosRevisionProveedor,
  RevisarFormularioCompras,
} from "../../../../API/Compras/Proveedores/ProveedoresRequest";

// ------------------ COMPONENTES DE NECESARIOS-------------------------------------------------


const DialogEstadoRevision = ({
  visible,
  setVisible,
  informacion,
  tokenInfo,
  Token,
  getCompanyInfo,
}) => {
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [estadosRevision, setEstadosRevision] = useState([]);
  const [idEstadoRevision, setIdEstadoRevision] = useState(null);
  const [comentarioCompras, setComentarioCompras] = useState("");
  const [comentarioFinanzas, setComentarioFinanzas] = useState("");
  const ESTADO_REVISADO_COMPRAS = "Revisado Compras";
  const ESTADO_REVISADO_FINANZAS = "Revisado Finanzas";
  const estadoSeleccionado = estadosRevision.find((estado) => estado.IdStatus === idEstadoRevision);
  const esRevisadoCompras = estadoSeleccionado?.StatusName === ESTADO_REVISADO_COMPRAS;
  const esRevisadoFinanzas = estadoSeleccionado?.StatusName === ESTADO_REVISADO_FINANZAS;

  const getInfo = async () => {
    setLoading(true);

    const estados = await getEstadosRevisionProveedor(Token);
    console.log("ESTADOS REVISION PROVEEDOR:", estados);
    setEstadosRevision(Array.isArray(estados) ? estados : []);

    setIdEstadoRevision(informacion?.IdStatusRevision || 67);
    setComentarioCompras(informacion?.ComentarioRevisadoCompras || "");
    setComentarioFinanzas(informacion?.ComentarioRevisadoFinanzas || "");

    setLoading(false);
  };

  const hideDialog = () => {
    setVisible(false);
    setIdEstadoRevision(null);
    setComentarioCompras("");
    setComentarioFinanzas("");
  };

  const cambiarEstado = async () => {
    if (!idEstadoRevision) {
      toastShow(toast, "warn", "Requerido", "Debe seleccionar un estado.");
      return;
    }
    if (esRevisadoCompras && !comentarioCompras.trim()) {
      toastShow(
        toast,
        "warn",
        "Requerido",
        "Debe ingresar el comentario de revisión de compras."
      );
      return;
    }

    if (esRevisadoFinanzas && !comentarioFinanzas.trim()) {
      toastShow(
        toast,
        "warn",
        "Requerido",
        "Debe ingresar el comentario de revisión de finanzas."
      );
      return;
    }

    const datosEnviar = {
      IdVendor: informacion?.IdVendor,
      IdStatusRevision: idEstadoRevision,
      IdUserRevision: tokenInfo?.IdUser || tokenInfo?.IdUserCreate || null,
      ComentarioRevisadoCompras: comentarioCompras,
      ComentarioRevisadoFinanzas: comentarioFinanzas,
    };

    setLoading(true);

    const result = await RevisarFormularioCompras(datosEnviar, Token);

    const respuesta = Array.isArray(result) ? result[0] : result?.data?.[0] || result;

    if (respuesta?.ERROR === 0) {
      toastShow(toast, "success", "Correcto", respuesta?.MSJ || "Estado actualizado.");

      if (getCompanyInfo && informacion?.IdVendor) {
        await getCompanyInfo({ IdCustomer: informacion.IdVendor });
      }

      setTimeout(() => {
        hideDialog();
        setLoading(false);
      }, 800);
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        respuesta?.MSJ || "Ocurrió un error al cambiar el estado de revisión."
      );
      setLoading(false);
    }
  };

  const footer = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Aceptar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={cambiarEstado}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (visible) {
      getInfo();
    }
  }, [visible]);

  return (
    <Dialog
      header={`Cambiar Estado Revisión a ${informacion?.CustomerName || "Proveedor"}`}
      visible={visible}
      style={{ width: "40vw" }}
      onHide={hideDialog}
      footer={footer}
    >
      <Toast ref={toast} />

      <div className="px-4">
        <p>
          Al cambiar el estado de revisión del proveedor, usted confirma que ha
          revisado y validado la información correspondiente.
        </p>

        {estadosRevision?.map((estado) => (
          <div key={estado.IdStatus} className="field-checkbox gap-2">
            <Checkbox
              inputId={`estado_${estado.IdStatus}`}
              checked={estado.IdStatus === idEstadoRevision}
              onChange={(e) => {
                const nuevoEstado = e.checked ? estado.IdStatus : null;
            
                setIdEstadoRevision(nuevoEstado);
            
                if (estado.StatusName === "Revisado Compras") {
                  setComentarioFinanzas("");
                }
            
                if (estado.StatusName === "Revisado Finanzas") {
                  setComentarioCompras("");
                }
            
                if (
                  estado.StatusName !== "Revisado Compras" &&
                  estado.StatusName !== "Revisado Finanzas"
                ) {
                  setComentarioCompras("");
                  setComentarioFinanzas("");
                }
              }}
            />
            <label
              htmlFor={`estado_${estado.IdStatus}`}
              className="ml-2"
              style={{ fontWeight: 600 }}
            >
              {estado.StatusName}
            </label>
          </div>
        ))}

        <div className="mt-4">
          <span className="p-float-label">
            <InputText
              value={comentarioCompras}
              onChange={(e) => setComentarioCompras(e.target.value)}
              style={{ width: "100%" }}
              disabled={!esRevisadoCompras}
            />
            <label>Comentario Revisado Compras</label>
          </span>
        </div>

        <div className="mt-4">
          <span className="p-float-label">
            <InputText
              value={comentarioFinanzas}
              onChange={(e) => setComentarioFinanzas(e.target.value)}
              style={{ width: "100%" }}
              disabled={!esRevisadoFinanzas}
            />
            <label>Comentario Revisado Finanzas</label>
          </span>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogEstadoRevision;